<template>
    <dialog-template 
        :append-to-body="true"
        :visible="dialogVisible" 
        @update:visible="cancel"
        :width="'400px'">
        <div class="fx-v-center" slot="title">
            <h1 class="fs-16 fw-600 color-333">{{ ['系统提示', '新建会员分组', '编辑会员分组', '删除会员分组'][['addMember', 'addGroup', 'editGroup', 'deteleGroup'].indexOf(mode)] }}</h1>
            <button v-if="mode === 'editGroup' && !groupInfo.is_default" @click="mode = 'deteleGroup'" class="text-btn danger delete-btn">删除分组</button>
        </div>
        <!-- 新建 / 编辑分组 -->
        <div v-if="mode === 'addGroup' || mode === 'editGroup'" class="form pl-11">
            <div class="item">
                <span class="title required">分组名称：</span>
                <div class="value">
                    <div class="input-wrapper">
                        <input placeholder="请输入分组名称" class="primary" ref="nameInput" maxlength="10" v-model="name" type="text" autofocus @input="inputSpaceLimit($data, 'name')"/>
                        <span class="suffix">{{name.length}}/10</span>
                    </div>
                </div>
            </div>
            <div class="item">
                <span class="title">分组说明：</span>
                <div class="value">
                    <div class="input-wrapper">
                        <textarea placeholder="请输入分组说明" maxlength="50" v-model="description" class="primary" type="text" @input="inputSpaceLimit($data, 'description')"/>
                        <span class="suffix" style="bottom: 10px; top: auto;">{{description.length}}/50</span>
                    </div>
                    
                </div>
            </div>
        </div>
        <!-- 删除分组 -->
        <div v-else-if="mode === 'deteleGroup'">
            <p style="font-size: 14px;color: #333333;font-weight: 500; text-align:center">确定要删除分组 <span style="color:#009688 ">{{name}}</span> 吗？</p>
            <p style="font-size: 12px;color: #666666; margin-top: 8px; text-align:center">
                删除此分组后，分组内客户将默认移动到 <span style="color: #009688">{{defaultMemberGroupName}}</span> 内
            </p>
        </div>
        <!-- 迁移会员 -->
        <div v-else>
            <p style="font-size: 14px;color: #333333;font-weight: 500; text-align:center">
                确定更换当前选中的 <span style="color: #009688">{{seletedNum}}个</span> 会员到 <span style="color: #009688">{{groupInfo.name}}</span> 吗？
            </p>
        </div>
        <div class="btn-wrapper" slot="footer" v-loading="loading">
            <el-button size="medium" type="primary" @click="onSubmit" :disabled="name === '' &&  mode !== 'addMember'" v-if="mode !== 'deteleGroup'">确认</el-button>
            <el-button type="danger" v-else @click="onSubmit" v-loading="loading">确认删除</el-button>
            <el-button size="medium" plain @click="cancel">取消</el-button>
        </div>
    </dialog-template>
</template>
<script lang="tsx">
import { createComponent, ref, createElement, computed, watch } from '@vue/composition-api'
import $fetch from '@/api'
import { openMessage, openWarning } from '@/utils/system.tsx'
import { debounceSubmit } from '@/utils/index'
import { inputSpaceLimit } from '@/utils'

export default createComponent({
    setup: (props, ctx) => {
        const dialogVisible = ref(false)
        const mode = ref('create')
        const loading = ref(false)
        const groupInfo = ref({})
        const seletedNum = ref(0)
        const name = ref('')
        const description = ref('')
        const defaultMemberGroupName = ref<string | null>('')

        function open(options: {
            mode: 'addMember' | 'addGroup' | 'editGroup' | 'deteleGroup',
            groupInfo: any
            seletedNum?: number
        }) {
            dialogVisible.value = true
            mode.value = options.mode
            groupInfo.value = {
                ...options.groupInfo,
                group_id: (options.groupInfo as any).id
            }
            if (options.seletedNum) {
                seletedNum.value = options.seletedNum
            }
            if (options.mode === 'editGroup') {
                name.value = options.groupInfo.name
                description.value = options.groupInfo.description || ''
            }
            defaultMemberGroupName.value = sessionStorage.getItem('defaultMemberGroupName')

        }

        const onSubmit = computed(() => debounceSubmit(() => {
            loading.value = true
            mode.value === 'addMember' ? addMember() : groupEdit()
        }))

        watch(dialogVisible, (val) => {
            if (!val) {
                cancel()
            }
        })

        function addMember() {
            ctx.emit('sureAddMember', {
                groupInfo: groupInfo.value,
                successCallback: () => {
                    loading.value = false
                    dialogVisible.value = false
                }
            })
        }

        function groupEdit() {
            loading.value = true
            $fetch.post({
                url: '/membership/editmembergroup',
                params: {
                    ...groupInfo.value,
                    name: name.value,
                    description: description.value,
                    status: mode.value === 'deteleGroup' ? -1 : undefined
                }
            }).then(() => {
                ctx.emit('groupSuccess', mode.value)
                dialogVisible.value = false
                if (mode.value === 'addGroup') return openMessage("success", "新建分组成功")
                if (mode.value === 'editGroup') return openMessage("success", "编辑分组成功")
                if (mode.value === 'deteleGroup') return openMessage("success", "删除分组成功")
            }).catch(e => {
                openMessage('error', e.message || '设置分组失败！')
            })
        }

        function cancel() {
            dialogVisible.value = false
            mode.value = ''
            groupInfo.value = {}
            seletedNum.value = 0
            name.value = ''
            description.value = '',
            loading.value = false
        }

        return {
            dialogVisible,
            mode,
            groupInfo,
            seletedNum,
            name,
            description,
            defaultMemberGroupName,
            loading,

            open,
            cancel,
            onSubmit,
            inputSpaceLimit
        }
    }
})
</script>

<style lang="scss" scoped>
.delete-btn {
    position: absolute;
    top: 14px;
    left: 110px;
}
.form {
    .item {
        display: flex;
        // align-items: center;

        & + .item {
            margin-top: 12px;
        }

        .title {
            padding-top: 10px;
            line-height: 20px;
            font-size: 14px;
            color: #333333;
        }

        .value {
            flex: 1;
            overflow: hidden;

            .input-wrapper {
                position: relative;
                width: 100%;
            }

            textarea {
                height: 80px;
            }

            .suffix {
                position: absolute;
                right: 8px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 14px;
                color: #999999;
            }
        }
    }
}

.btn-wrapper {
    text-align: center;
}
</style>
